export const findQueuesByMarketId = (marketId, queues) =>
	queues.filter((queue) => queue.market === marketId);
